export default "__VITE_ASSET__BaeN3Z7q__"